export const messages = {
  en: {
    oweFeeCallable: {
      search: {
        title: 'Search Conditions',
        ownerName: 'Owner Name',
        ownerNamePlaceholder: 'Please enter owner name',
        feeName: 'Fee Name',
        feeNamePlaceholder: 'Please enter fee name',
        callableWay: 'Callable Way',
        callableWayPlaceholder: 'Please select callable way',
        staffName: 'Staff Name',
        staffNamePlaceholder: 'Please enter staff name',
        state: 'State',
        statePlaceholder: 'Please select state'
      },
      list: {
        title: 'Call Records',
        register: 'Register',
        call: 'Call'
      },
      table: {
        id: 'ID',
        ownerName: 'Owner Name',
        payerObjName: 'Payer Object',
        feeName: 'Fee Name',
        amountdOwed: 'Amount Owed',
        timeRange: 'Time Range',
        callableWayName: 'Callable Way',
        staffName: 'Staff Name',
        stateName: 'State',
        remark: 'Remark',
        createTime: 'Create Time'
      },
      write: {
        title: 'Call Registration',
        roomName: 'Room',
        feeName: 'Call Fees',
        remark: 'Remark',
        remarkPlaceholder: 'Please enter remark',
        success: 'Registration successful',
        error: 'Registration failed'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this call record?',
        success: 'Delete successful',
        error: 'Delete failed'
      },
      fetchError: 'Failed to fetch data',
      selectRoomFirst: 'Please select a room first'
    }
  },
  zh: {
    oweFeeCallable: {
      search: {
        title: '查询条件',
        ownerName: '业主名称',
        ownerNamePlaceholder: '请输入业主名称',
        feeName: '费用名称',
        feeNamePlaceholder: '请输入费用名称',
        callableWay: '催缴方式',
        callableWayPlaceholder: '请选择催缴方式',
        staffName: '催缴人',
        staffNamePlaceholder: '请输入催缴人',
        state: '状态',
        statePlaceholder: '请选择状态'
      },
      list: {
        title: '催缴记录',
        register: '登记',
        call: '催缴'
      },
      table: {
        id: '编号',
        ownerName: '业主名称',
        payerObjName: '付费对象',
        feeName: '费用名称',
        amountdOwed: '催缴金额(元)',
        timeRange: '欠费时间段',
        callableWayName: '催缴方式',
        staffName: '催缴人',
        stateName: '状态',
        remark: '说明',
        createTime: '创建时间'
      },
      write: {
        title: '催缴登记',
        roomName: '登记房屋',
        feeName: '催缴费用',
        remark: '催缴说明',
        remarkPlaceholder: '请输入备注',
        success: '登记成功',
        error: '登记失败'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除欠费催缴记录吗？',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取数据失败',
      selectRoomFirst: '请先选择房屋'
    }
  }
}